<template>
  <div>
    <div class="projects-list">
      <div
        class="project-box"
        style="cursor: pointer"
        v-for="current in datatabla.results"
        v-bind:key="current.id"
        @click="rowClick(current)"
      >
        <div class="project-head">
          <div class="project-title">
            <h5 class="font-weight-bold">#{{ current.numero }}</h5>
            <div>
              <span v-if="current.estado == 'A'" class="badge badge-success"
                ><small> Abierto</small></span
              >

              <span v-if="current.estado == 'C'" class="badge badge-dark"
                ><small>Finalizado</small></span
              >
              <span v-if="current.estado == '9'" class="badge badge-danger"
                ><small>Anulado</small></span
              >
            </div>
            <small>{{ current.barra }}</small>
            <span>{{ current.comentarios }}</span>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
            <small
              ><br />Tienda: {{ current.tienda_obj.codigo }} -
              {{ current.tienda_obj.nombre }}</small
            >
          </div>
        </div>
        <div class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div v-if="current.encargado_obj" class="label">Encargado</div>
                    <div v-if="current.encargado_obj">
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.encargado_obj.name }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Piloto</div>
                    <div>
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.piloto_obj.usuario.name }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Vehiculo</div>
                    <div>
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.vehiculo_obj.nombre }} -{{
                            current.vehiculo_obj.placa
                          }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  props: ["datatabla"],
  components: {
    PaginationComponent,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      this.$router.push({
        name: name,
        params: params,
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-asignar-pedido-reparto-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-asignar-pedido-reparto-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
